// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"f58b0737c3533887bd3b","883":"e920c9abf369d5e5ac0f"}[chunkId] + ".js";
};